import React from 'react';
import BookList from '../components/book-list/BookList';
import Form from '../components/form/Form';

export default function Books() {
  return (
    <>
      <BookList />
      <Form />
    </>
  );
}
